.slider-field {
  width: var(--form-field--width);
  max-width: var(--form-field--max-width);
  margin: 1em 0;
}

.slider-field__input {
  width: var(--form-field--width);
  max-width: var(--form-field--max-width);
  -webkit-appearance: none;
  background: transparent;
  margin-bottom: 0.5em;
}

/* Style the track */
.slider-field__input::-webkit-slider-runnable-track {
  height: 4px;
  width: 100%;
  background: var(--fdt-semantic-color-foreground-inactive);
  border-radius: 2px;
}

.slider-field__input::-moz-range-track {
  height: 4px;
  width: 100%;
  background: var(--fdt-semantic-color-foreground-inactive);
  border-radius: 2px;
}

/* Style the thumb */
.slider-field__input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: var(--fdt-core-color-primary-600);
  border-radius: 50%;
  cursor: pointer;
  margin-top: -6px; /* Adjust depending on track height */
}

.slider-field__input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: var(--fdt-core-color-primary-600);
  border-radius: 50%;
  cursor: pointer;
}

/* Labels under the slider */
.slider-field__labels {
  display: flex;
  width: var(--form-field--width);
  max-width: var(--form-field--max-width);
  justify-content: space-between;
  font-size: 0.9em;
  color: var(--fdt-semantic-color-foreground-inactive);
}

/* Chrome, Safari, Edge */
.slider-field__input::-webkit-slider-runnable-track {
  background: linear-gradient(to right, var(--fdt-core-color-primary-600) 0%, var(--fdt-core-color-primary-600) calc((var(--val, 0) - var(--min, 0)) / (var(--max, 100) - var(--min, 0)) * 100%), var(--fdt-semantic-color-foreground-inactive) calc((var(--val, 0) - var(--min, 0)) / (var(--max, 100) - var(--min, 0)) * 100%), var(--fdt-semantic-color-foreground-inactive) 100%);
}

.slider-field__input {
  --min: 0;
  --max: 100;
  --val: 50;
}

/* Firefox */
.slider-field__input::-moz-range-progress {
  background-color: var(--fdt-core-color-primary-600);
  height: 4px;
}

.slider-field__input::-moz-range-track {
  background-color: var(--fdt-semantic-color-foreground-inactive);
  height: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */